"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ShoppingBagLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ShoppingBagLinear = function ShoppingBagLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 13.311l-.464-7.994c-.008-.797-.642-1.444-1.42-1.444h-2.354C10.77 2.601 9.694 1.6 8.398 1.6c-1.295 0-2.372 1.001-2.563 2.273H3.484c-.778 0-1.412.647-1.42 1.444L1.6 13.31l-.001.027c0 .806.637 1.462 1.42 1.462h10.76c.783 0 1.42-.655 1.42-1.461v-.028zM8.397 2.845c.628 0 1.16.435 1.33 1.028h-2.66c.171-.593.703-1.028 1.33-1.028zm5.382 10.711H3.02a.213.213 0 01-.213-.207l.462-7.988v-.03c0-.119.095-.214.214-.214H5.8v2.275c0 .343.27.622.603.622a.613.613 0 00.603-.622V5.117H9.78v2.275c0 .343.27.622.602.622a.612.612 0 00.603-.622V5.117h2.33c.121 0 .215.095.215.215v.028l.463 7.988a.214.214 0 01-.213.208z",
    fill: "currentColor"
  }));
};

exports.ShoppingBagLinear = ShoppingBagLinear;
var _default = ShoppingBagLinear;
exports.default = _default;